import { Button } from '@schibsted-svp/react-ui';
import css from './PosterUploader.module.scss';

interface PosterUploaderProps {
    disabled?: boolean;
    handlePosterChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    isEmpty: boolean;
    minimumSize: readonly [number, number];
    maximumSize: readonly [number, number];
}

function PosterUploader({
    disabled = false,
    handlePosterChange,
    isEmpty,
    minimumSize,
    maximumSize,
}: PosterUploaderProps) {
    const [minWidth, minHeight] = minimumSize;
    const [maxWidth, maxHeight] = maximumSize;

    const handleClick = (event) => {
        // eslint-disable-next-line no-param-reassign
        event.target.value = null;
    };

    return (
        <div className={css.wrapper}>
            <h5>Upload image</h5>
            <div className={css.content}>{`Minimum image resolution ${minWidth}x${minHeight}`}</div>
            <div className={css.content}>{`Maximum image resolution ${maxWidth}x${maxHeight}`}</div>
            {!isEmpty ? (
                <Button className={css.button} type="label" size="small" disabled={disabled}>
                    Replace image
                    <input
                        id="uploadInput"
                        type="file"
                        accept="image/*"
                        onClick={handleClick}
                        onChange={handlePosterChange}
                        disabled={disabled}
                    />
                </Button>
            ) : null}
        </div>
    );
}

export default PosterUploader;
